import {NgModule} from '@angular/core';
import {EntityDataService, EntityServices} from '@ngrx/data';
import {MedicalReportConverter} from './api/entity/medicalReport.converter';
import {MedicalReportDataService} from './impl/service/ngrx/medicalReportData.service';
import {MedicalReportRepository} from './impl/service/ngrx/medicalReport.repository';
import {MedicalReportDataServiceAdapter} from './impl/service/ngrx/medicalReportDataService.adapter';
import {errorMessages} from '../../core/error/errorMessages';
import {ReportingModule} from "../../reporting/reporting.module";

@NgModule({
    providers: [
        MedicalReportConverter,
        MedicalReportDataService,
        MedicalReportRepository,
        MedicalReportDataServiceAdapter,
    ],
    imports: [
        ReportingModule
    ]
})
export class MedicalReportModule {
    constructor(entityDataService: EntityDataService,
                entityServices: EntityServices,
                dataService: MedicalReportDataService,
                repository: MedicalReportRepository) {

        entityDataService.registerServices({
            MedicalReport: dataService,
        });

        entityServices.registerEntityCollectionServices({
            MedicalReport: repository,
        });

        errorMessages.set('REPORT_DEFINITION_SAVE_DEFAULT_CONTENT_MISSING_INTRO', 'Ajoutez [INTRO] dans le contenu par défaut ou supprimer l\'introduction par défaut');
        errorMessages.set('REPORT_DEFINITION_SAVE_DEFAULT_CONTENT_MISSING_SALUTATION', 'Ajoutez [SALUTATION] dans le contenu par défaut ou supprimer la salutation par défaut')
    }
}
